// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentDocumentsItemContainer_container_3wxBe","spinAround":"RecentDocumentsItemContainer_spinAround_1xxkf"};